module.exports = __webpack_public_path__ + "img/icon3.3ef2b94a.png";